// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require(105)('Set');
